import {
	Button,
	Divider,
	Flex,
	Icon,
	Image,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Stack,
	Text
} from "@chakra-ui/react";
import { format } from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';
import { FaMapMarkerAlt, FaStore } from "react-icons/fa";

import { useAuth } from "../../hooks/auth";
import { useCart } from '../../hooks/cart';
import { formatPrice } from "../../utils/format";

interface ModalConferenciaProps {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
	handleSubmitPedido: () => void;
}

const ModalConferencia: React.FC<ModalConferenciaProps> = ({
	isOpen,
	onRequestClose,
	handleSubmitPedido,
}) => {
	const { user } = useAuth();
	const { cart } = useCart();

	return (
		<Modal
			isCentered={true}
			size="xl"
			isOpen={isOpen}
			blockScrollOnMount={false}
			onClose={() => onRequestClose(false)}
		>
			<ModalOverlay />

			<ModalContent mt="auto">
				<ModalCloseButton />

				<ModalHeader mb="0" pb="0">
					<Text>Finalizar Pedido</Text>
				</ModalHeader>

				<ModalBody mt="0">
					{/* OPERAÇÂO */}
					<Flex px="2" py="1" align="center">
						<Text fontWeight="500" fontSize="13px" color="gray.300">Operação:</Text>
						<Text ml="2" fontSize="15px" fontWeight="500">{cart.operacao.nome}</Text>
					</Flex>

					<Divider orientation='horizontal' size="sm" />

					{/* VENDEDOR */}
					<Flex flexDir="column" px="2" py="1">
						<Text fontSize="13px" fontWeight="500" color="gray.300" mb="-1">Vendedor</Text>
						<Flex justify="space-between" pl="1">
							<Text fontSize="15px" fontWeight="500" color="gray.600">{user.nome}</Text>
							<Text fontSize="13px" fontWeight="500" color="gray.500">{user.email}</Text>
						</Flex>
					</Flex>

					<Divider orientation='horizontal' size="sm" />

					{/* CLIENTE */}
					<Flex flexDir="column" px="2" py="1">
						<Text fontSize="13px" fontWeight="500" color="gray.300" mb="-1">
							{cart.consumidor ? 'Consumidor' : 'Cliente'}
						</Text>
						<Flex justify="space-between" pl="1">
							<Text fontSize="15px" fontWeight="500" color="gray.600">{cart.cliente.nome}</Text>
							<Text fontSize="14px" fontWeight="500" color="gray.500">{cart.cliente.doc}</Text>
						</Flex>
					</Flex>

					<Divider orientation='horizontal' size="sm" />

					{/* INDICADOR */}
					{cart.indicador.id && (
						<>
							<Flex flexDir="column" px="2" py="1">
								<Text
									fontSize="13px"
									fontWeight="500"
									textTransform="capitalize"
									color="gray.300"
									mb="-1"
								>
									{cart.operacao.indicador_desc}
								</Text>
								<Flex justify="space-between" pl="1">
									<Text fontSize="15px" fontWeight="500" color="gray.600">
										{cart.indicador.nome}
									</Text>
									<Text fontSize="14px" fontWeight="500" color="gray.500">
										{cart.indicador.doc}
									</Text>
								</Flex>
							</Flex>

							<Divider orientation='horizontal' size="sm" />
						</>
					)}

					{/* ENDERECO ENTREGA */}
					<Flex flexDir="column" p="2" pb="4">
						<Text fontSize="15" color="gray.300" mb="2">
							{cart.retirar ? 'Retirar em:' : 'Entrega em:'}
						</Text>

						<Flex align="center">
							<Flex
								w="50px"
								h="50px"
								mr="4"
								bg="gray.100"
								justify="center"
								align="center"
								borderRadius={8}
							>
								<Icon as={cart.retirar ? FaStore : FaMapMarkerAlt} />
							</Flex>

							<Flex flexDir='column'>
								{cart.endereco_entrega?.endereco ? (
									<>
										<Text fontSize="18" color="gray.700">
											{cart.endereco_entrega?.endereco}
											{cart.endereco_entrega.num && `, ${cart.endereco_entrega.num}`}
										</Text>
										<Text fontSize="14" color="gray.400">
											{cart.endereco_entrega.comp && `${cart.endereco_entrega.comp}, `}
											{cart.endereco_entrega?.bai}
											{cart.endereco_entrega.cid && `, ${cart.endereco_entrega.cid}`}
											{cart.endereco_entrega?.uf && ` - ${cart.endereco_entrega.uf}`}
										</Text>
									</>
								) : (
									<>
										<Text fontSize="18" color="gray.700">
											Nenhum endereço
										</Text>
										<Text fontSize="14" color="gray.400">
											Cadastre um endereço para entrega
										</Text>
									</>
								)}

							</Flex>
						</Flex>
					</Flex>

					<Divider orientation='horizontal' size="sm" />

					{/* ENTREGA */}
					<Flex p="2" align="center">
						<Flex
							flexDir="column"
							justify="center"
							align="center"
							mr="4"
							pt="0"
							w="50px"
							h="50px"
						>
							<Text
								bg="blue.500"
								w="100%"
								px="2.5"
								color="white"
								fontSize="13"
                fontWeight={500}
								align="center"
								borderWidth={1}
								borderColor="blue.500"
								borderTopRightRadius={8}
								borderTopLeftRadius={8}
								textTransform="capitalize"
							>
								{cart.agendar ?
									`${format(new Date(cart.agendamento.data), 'MMM', {locale: ptBR })}.`
									: 'Dias'
								}
							</Text>
							<Text
								align="center"
								fontSize="18"
								fontWeight="500"
								w="100%"
								p="1"
								borderLeftWidth={1}
								borderRightWidth={1}
								borderBottomWidth={1}
								borderBottomRightRadius={8}
								borderBottomLeftRadius={8}
								borderColor="gray.100"
							>
								{cart.agendar ?
									format(new Date(cart.agendamento.data), 'd')
									: '5'
								}
							</Text>
						</Flex>

						<Flex flexDir="column">
							<Text color="gray.1000">
								{cart.agendar ? 'Horário Agendado' : 'Entrega Padrão'}
							</Text>
							<Text fontSize={15} color="gray.400">
								{cart.agendar && cart.agendamento.data
									? `${format(new Date(cart.agendamento.data),
										"EEEE', dia' dd 'de' MMMM 'de' yyyy 'às' ",
										{ locale: ptBR },
									)} ${cart.agendamento.hora}h`
									: 'Até 5 dias uteis'
								}
							</Text>
							<Text fontSize={15}>R$ 0,00</Text>
						</Flex>
					</Flex>

					{/* PAGAMENTOS */}
					{cart.operacao.pagto === 'S' && (
						<>
							<Divider orientation='horizontal' size="sm" />

							<Flex flexDir="column" p="2" my="2">
								<Flex flexDir="column">
									{cart.pagamentos && cart.pagamentos.map(pay => {
										return (
											<Flex
												key={pay.id}
												justify="space-between"
												w="100%"
												p="2"
												my="1"
												borderWidth={1}
												borderColor="gray.100"
												borderRadius={8}
											>
												<Stack direction="row" spacing="2">
													<Image w="30" h="25" src={pay.url_pay} alt={pay.name_pay} />
													<Text>{pay.name_pay}</Text>
													<Text>{pay.qtd_parcel}x</Text>
												</Stack>

												<Stack
													direction="row"
													spacing="2"
													justify="center"
													align="center"
												>
													<Text>{formatPrice(pay.vlr_pay)}</Text>
												</Stack>
											</Flex>
										)
									})}
								</Flex>

								<Flex flexDir="column" pt="2">
									<Flex justify="space-between">
										<Text fontWeight="500" color="gray.400">SubTotal</Text>
										<Text fontWeight="500" color="gray.400">{formatPrice(cart.subTotal)}</Text>
									</Flex>

									<Flex justify="space-between">
										<Text fontWeight="500" color="gray.400">Troco</Text>
										<Text fontWeight="500" color="gray.400">{formatPrice(cart.troco)}</Text>
									</Flex>

									<Flex justify="space-between">
										<Text fontWeight="500">Total</Text>
										<Text fontWeight="500">{formatPrice(cart.total)}</Text>
									</Flex>

									<Flex justify="space-between">
										<Text
											fontWeight="500"
											color={cart.falta > 0 ? "gray.900" : "gray.500"}
										>
											Falta
										</Text>
										<Text
											fontWeight="500"
											color={cart.falta > 0 ? "gray.900" : "gray.500"}
										>
											{formatPrice(cart.falta)}
										</Text>
									</Flex>
								</Flex>
							</Flex>
						</>
					)}
				</ModalBody>

				<ModalFooter pt="2">
					<Button
						colorScheme="blue"
						ml="4"
						onClick={handleSubmitPedido}
					>
						Confirmar
					</Button>

					<Button
						colorScheme="blackAlpha"
						ml="4"
						onClick={() => onRequestClose(false)}
					>
						Cancelar
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export default ModalConferencia;
